import { render, staticRenderFns } from "./home.vue?vue&type=template&id=63388d71&scoped=true&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"
import style0 from "./home.vue?vue&type=style&index=0&lang=less&"
import style1 from "./home.vue?vue&type=style&index=1&id=63388d71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63388d71",
  null
  
)

export default component.exports